<template>
  <!--上传照片-->
  <div class="uploadVideo activity-upload-video">
    <div class="container">
      <div v-if="isLogin" class="userInfo login">
        <div class="info-item">
          <div class="info-text" style='white-space:pre;'>姓 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    名:</div>
          <div class="info-detail">{{userInfo.contactPerson}}</div>
        </div>
        <div class="info-item">
          <div class="info-text">手 机 号 码:</div>
                    <div class="info-detail">{{userInfo.contactMobile}}</div>
        </div>
        <div class="info-item">
          <div class="info-text">城 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    市:</div>
                    <div class="info-detail">{{userInfo.cityName}}</div>
        </div>
        <div class="info-item">
          <div class="info-text">修理厂名称:</div>
                    <div class="info-detail">{{userInfo.clientName}}</div>
        </div>
      </div>

      <div v-else class="userInfo">
        <div class="info-item">
          <div class="info-text">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  名:</div>
          <div class="info-input">
            <input v-model="newUserInfo.personName" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">手 机 号 码:</div>
          <div class="info-input">
            <input v-model="newUserInfo.personMobile" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  市:</div>
          <div class="info-input">
            <input v-model="newUserInfo.cityName" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">修理厂名称:</div>
          <div class="info-input">
            <input v-model="newUserInfo.workshopName" />
          </div>
        </div>
      </div>

      <div class="upload">
        <!-- <van-uploader :after-read="businessafterRead"></van-uploader> -->

        <van-uploader
          v-if="!fileUri"
          v-model="videoList"
          :max-count="1"
          accept="video/*"
          :after-read="afterVideoRead"
          result-type="file"
        >
          <img
            class="photosize"
            src="../../assets/images/activity/uploadVideo/upload-item.png"
          />
        </van-uploader>

        <div v-else class="video-wrapper">
          <video class="video" :src="getVideo()" controls="controls"></video>
          <img
            @click="handleDeleteVideo"
            class="video-delete"
            src="../../assets/images/activity/form-verification-off.png"
          >
        </div>

        <img
          @click="handleSubmit()"
          src="../../assets/images/activity/uploadVideo/submit.png"
        />
      </div>
      <div class="submit-btn"></div>
    </div>

    <div class="info-content">
    </div>
  </div>
</template>

<script>
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
// import { Toast } from 'vant'
import fileApi from '@/api/file'
export default {
  name: 'Upload',
  data () {
    return {
      loading: false,
      businessPhotoId: '',
      videoList: [],
      activityCode: 'WS-VIDEO-2021',
      videoFileId: '',
      fileUri: '',
      userInfo: {},
      newUserInfo: {
        personName: '',
        personMobile: '',
        workshopName: '',
        cityName: ''
      },
      isLogin: false,
      from: ''
    }
  },
  mounted () {
    const fromSource = this.$route.query.from
    if (fromSource) {
      sessionStorage.setItem('workshop-video-from', fromSource)
      commonUtils.reportViewTrace()
    }
    this.userInfo = userUtils.getClientInfo()
    if (!this.userInfo) {
      this.$dialog
        .confirm({
          title: '登录提醒',
          message: '是否是易加用户?',
          confirmButtonText: '是',
          cancelButtonText: '否'
        })
        .then(() => {
          this.$router.push({
            name: 'login',
            params: { redirectUrl: this.$route.name }
          })
        })
        .catch(() => {})
    } else {
      this.isLogin = true
    }
  },
  methods: {
    afterVideoRead (file, detail) {
      console.log('afterVideoRead', file.file.type)
      if (new Date().getTime() < 1623628800000) {
        this.$toast('活动将于2021.6.14开始')
        this.handleDeleteVideo()
        return false
      }
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov',
          'video/quicktime',
          'video/x-quicktime'
        ].indexOf(file.file.type) === -1
      ) {
        this.$toast('请上传正确的视频格式')
        this.handleDeleteVideo()
        return false
      }
      const isLt100M = file.file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$toast('上传视频大小不能超过100MB')
        this.handleDeleteVideo()
        return false
      }

      file.status = 'uploading'
      file.message = '上传中...'

      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            // this.submitData.videoFileId =
            //   response.data.resultData.fileDTO.fileId
            // file.fileDTO = response.data.resultData.fileDTO
            let fileDTO = response.data.resultData.fileDTO
            // this.videoId = fileDTO.fileId
            this.videoFileId = fileDTO.fileId
            this.fileUri = fileDTO.fileUri
            file.status = ''
            file.message = ''
          } else {
            this.handleDeleteVideo()
          }
        })
        .catch((error) => {
          console.log(error)
          this.handleDeleteVideo()
        })
    },
    // 重置参数
    resetInfo () {
      this.videoList = []
      this.videoFileId = ''
      this.newUserInfo = {
        personName: '',
        personMobile: '',
        workshopName: '',
        cityName: ''
      }
    },
    // 提交按钮
    handleSubmit () {
      if (!this.isLogin) {
        if (!this.newUserInfo.personName) {
          this.$toast('请输入姓名')
          return
        }
        if (!this.newUserInfo.personMobile) {
          this.$toast.fail('请输入手机号码')
          return
        }
        if (this.newUserInfo.personMobile.length !== 11 || !(/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.newUserInfo.personMobile))) {
          this.$toast.fail('请输入有效手机号码')
          return
        }
        if (!this.newUserInfo.cityName) {
          this.$toast.fail('请输入城市')
          return
        }
        if (!this.newUserInfo.workshopName) {
          this.$toast.fail('请输入修理厂名称')
          return
        }
      }
      if (!this.fileUri || !this.videoFileId) {
        this.$toast.fail('视频未上传或正在上传中')
        return
      }
      let data = {
        fromSource: sessionStorage.getItem('workshop-video-from')
      }

      if (this.isLogin) {
        data = Object.assign(data, {
          videoFileId: this.videoFileId,
          activityCode: this.activityCode
        })
      } else {
        this.newUserInfo.videoFileId = this.videoFileId
        this.newUserInfo.activityCode = this.activityCode
        data = Object.assign(data, this.newUserInfo)
      }
      this.$toast.loading({
        message: '报名信息提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.uploadVideo(data)
        .then(response => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            this.resetInfo()
            this.$dialog.alert({ message: '报名信息提交成功，请等待后台审核结果。' })
              .then(() => {
                // 提交成功后跳转到活动详情页
                this.$router.replace({
                  name: 'activity/workshop-video/detail'
                })
              })
          }
        })
        .catch(error => {
          this.$toast.clear()
          console.log(error)
          this.$toast.fail('报名信息提交失败')
        })
    },
    getVideo () {
      return commonUtils.getImageUrl(this.fileUri)
    },
    handleVideoPreview (uri) {
      window.open(commonUtils.getImageUrl(uri))
    },
    handleDeleteVideo () {
      this.videoList = []
      this.fileUri = ''
      this.videoFileId = ''
    }
  }
}
</script>

<style lang="less" scoped>
.uploadVideo {
  width: 100vw;
  height: 100%;
  min-height: 500px;
  background-color: rgba(0, 0, 0, 0.233);
  background-image: url("../../assets/images/activity/uploadVideo/bg-black.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.container {
  position: relative;
  top: 14vh;
  left: 3vw;
  width: 94vw;
  height: 85%;
  min-height: 450px;
  background-image: url("../../assets/images/activity/uploadVideo/upload-dialog.png");
  background-size: 100% 100%;
}
.userInfo {
  width: 70vw;
  margin: 0 auto;
  position: relative;
  top: 13vh;
}
.info-item {
  height: 30px;
  color: white;
  margin-bottom: 10px;
  display: flex;
  line-height: 30px;
}
.info-detail{
  margin-left: 20px;
}
.login{
  margin-right: 20px;
}
.info-text {
  width: 30%;
  height: 100%;
  text-align: justify;
}
.info-input {
  width: 70%;
  height: 100%;
  background-image: url("../../assets/images/activity/uploadVideo/item.png");
  background-size: 100% 100%;
}
.info-input input {
  padding-left: 2%;
  width: 98%;
  height: 100%;
  background: none;
  outline: none;
  border: 0px;
}
.upload {
  width: 60%;
  margin: 0 auto;
  margin-top: 18vh;
  text-align: center;
}
.upload img {
  width: 180px;
  margin-bottom: 10px;
}
.van-cell{
  background-color: rgba(131, 131, 131, 0.568);
  color: white;
}
.van-cell__value ,.van-field__value{
  width: 100%;
  height: 30px;
  background-image: url('../../assets/images/activity/uploadVideo/item.png');
}
.video-wrapper {
  position: relative;
  text-align: center;
  height: 140px;
  .video {
    width: 100%;
    max-height: 130px;
    object-fit:fill;
  }
  .video-delete {
    position: absolute;
    top: -20px;
    right: -20px;
    width: 20px;
    height: 20px;
  }
}
</style>
